<!--
 * @Name: LoginType
 * @Description: 登录类型
 * @Author: xiadongxue
 * @Date: 2022-09-21 10:35:05
 * @Editors: xiadongxue
-->
<template>
<el-dialog
    :visible.sync="visible"
    v-loading="loading"
    title="设置登录类型"
    @close="close"
    width="600px">
    <el-form
        size="small"
        ref="form"
        :rules="rules"
        :model="form"
        label-width="140px">
        <el-form-item
            prop="loginType"
            label="登录类型："
            required>
            <el-radio-group
                v-model="form.loginType"
                @change="loginTypeChange">
                <el-radio :label="0">短信</el-radio>
                <el-radio :label="1">邮箱验证码</el-radio>
                <el-radio :label="2">Google Auth</el-radio>
            </el-radio-group>
        </el-form-item>
        <template v-if="form.loginType === 2 && data && data.googleSecretKey">
            <div style="color:red;text-align:center;font-size:12px;">注*  如果您想修改登录验证法方式为 Google Auth，请下载<a style="color: red;text-decoration: underline" href="http://confluence.taiyouxi.net/pages/viewpage.action?pageId=64559950">Google Auth</a>，并扫码绑定。</div>
            <el-form-item label="google密钥：">{{data.googleSecretKey}}</el-form-item>
            <el-form-item label="二维码：">
                <img style="width:200px;" :src="data.googleSecretCaptcha" alt="" />
            </el-form-item>
        </template>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button
            @click="close"
            size="small">取消</el-button>
        <el-button
            size="small"
            type="danger"
            @click="toSubmit">确定</el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    setLoginType,
    getTwofactor,
    generatorTwofactor
} from '@/api'
import Emitter from "@/mixins/emitter"
import {
    mapGetters
} from 'vuex'
export default {
    name: 'loginType',
    mixins: [Emitter],
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['userInfo']),
    },
    data() {
        return {
            loading: false,
            visible: true,
            rules: {
                loginType: [{
                    required: true,
                    message: '请选择'
                }]
            },
            form: {
                loginType: ''
            },
            data: {}
        }
    },
    created() {
        this.form.loginType = this.userInfo.loginType
        this.toGetTwofactor()
    },
    methods: {
        //关闭弹窗
        close() {
            this.$emit('update:show', false)
        },
        //提交校验
        toSubmit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.toSave()
                } else {
                    return false;
                }
            });
        },
        //设置登录类型
        async toSave() {
            try {
                this.loading = true
                let {
                    code
                } = await setLoginType({
                    userId: this.userInfo.userId,
                    loginType: this.form.loginType
                })
                if (code === 0) {
                    this.$message.success('设置成功')
                    this.dispatch('index', 'set.loginType')
                    this.close()
                }
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        //获取google秘钥
        async toGetTwofactor() {
            try {
                let {
                    result,
                    code
                } = await getTwofactor({
                    userId: this.userInfo.userId
                })
                if (code === 0 && result) {
                    this.data = result
                }
            } catch (error) {
                console.log(error)
            }
        },
        //生成google秘钥
        async loginTypeChange(value) {
            try {
                if (value === 2 && (!this.data || !this.data.googleSecretKey)) {
                    let {
                        result,
                        code
                    } = await generatorTwofactor({
                        userId: this.userInfo.userId
                    })
                    if (code === 0 && result.googleSecretKey) {
                        this.data = result
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>
